package one.healthium.today.ui.models

import one.healthium.base.utils.Formatters.formatWeight
import kotlin.time.Instant

data class UpdateWeightUiModel(
    val currentWeight: Float,
    val date: Instant?,
    val isMetric: Boolean,
) {
    val displayValue = currentWeight.formatWeight(isMetric)
}
